import {AnalysisMainViewItemType} from 'analysis-tool/ui/main-view/MainViewTypes';
import {InsightsFeature, RegistryFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {DataFrameCreationMethod, DataFrameCreationMethodOptions} from './DataFrameCreationTypes';

export const DATA_FRAME_CREATION_METHOD_OPTIONS: {
  [key in DataFrameCreationMethod]: DataFrameCreationMethodOptions;
} = {
  [DataFrameCreationMethod.DATA_CATALOG]: {
    stepType: PipelineStepType.DATA_CATALOG_DATASET,
    initializationViewItem: {type: AnalysisMainViewItemType.DATA_CATALOG_DATASET_CONFIGURATION},
    text: 'From dataset',
    analyticsEventName: 'data_catalog',
    isEnabled: () => BenchlingConfig.ENABLE_ANALYSIS_TOOL_WITHOUT_INSIGHTS,
    canReplace: true,
    dataTestAttrs: {component: 'DataFrameCreationMethod', element: 'dataCatalog'},
  },
  [DataFrameCreationMethod.INSIGHTS_BLOCK]: {
    stepType: PipelineStepType.INITIALIZE_DATASET,
    initializationViewItem: {type: AnalysisMainViewItemType.INSIGHTS_BLOCK_DATASET_CONFIGURATION},
    text: 'From dashboard query',
    analyticsEventName: 'insights_block',
    isEnabled: () => isFeatureEnabled({feature: InsightsFeature.INSIGHTS_DISCOVER}),
    canReplace: true,
    dataTestAttrs: {component: 'DataFrameCreationMethod', element: 'insightsBlock'},
  },
  [DataFrameCreationMethod.REGISTRY_SCHEMA]: {
    stepType: PipelineStepType.REGISTRY_SCHEMA_DATASET,
    initializationViewItem: {type: AnalysisMainViewItemType.REGISTRY_SCHEMA_DATASET_CONFIGURATION},
    // Registry is capitalized because it is a product
    text: 'From Registry schema',
    analyticsEventName: 'registry_schema',
    isEnabled: () => isFeatureEnabled({feature: RegistryFeature.REGISTRY_DISCOVER}),
    canReplace: true,
    dataTestAttrs: {component: 'DataFrameCreationMethod', element: 'registrySchema'},
  },
  [DataFrameCreationMethod.PLATE_SCHEMA]: {
    stepType: PipelineStepType.PLATE_SCHEMA_DATASET,
    initializationViewItem: {type: AnalysisMainViewItemType.PLATE_SCHEMA_DATASET_CONFIGURATION},
    text: 'From plate schema',
    analyticsEventName: 'plate_schema',
    isEnabled: () => BenchlingConfig.DOMAIN_GRAPH_ENABLE_EXPERIMENTAL_SCHEMAS,
    canReplace: true,
    dataTestAttrs: {component: 'DataFrameCreationMethod', element: 'plateSchema'},
  },
  [DataFrameCreationMethod.UPLOAD_CSV]: {
    stepType: PipelineStepType.UPLOAD_CSV_DATASET,
    initializationViewItem: {type: AnalysisMainViewItemType.UPLOAD_CSV_DATASET_CONFIGURATION},
    text: 'From CSV',
    analyticsEventName: 'upload_csv',
    isEnabled: () => true,
    canReplace: true,
    dataTestAttrs: {component: 'DataFrameCreationMethod', element: 'uploadCSV'},
  },
  [DataFrameCreationMethod.COMBINE_DATA_FRAMES]: {
    stepType: PipelineStepType.JOIN,
    initializationViewItem: {type: AnalysisMainViewItemType.COMBINE_DATA_FRAMES},
    text: 'By combining tables',
    analyticsEventName: 'combine_data_frames',
    isEnabled: () => true,
    canReplace: true,
    dataTestAttrs: {component: 'DataFrameCreationMethod', element: 'combineTables'},
  },
  [DataFrameCreationMethod.LOOK_UP]: {
    stepType: PipelineStepType.LOOK_UP,
    initializationViewItem: {type: AnalysisMainViewItemType.LOOK_UP},
    text: 'From look up',
    analyticsEventName: 'look_up',
    isEnabled: () => true,
    canReplace: false,
    dataTestAttrs: {component: 'DataFrameCreationMethod', element: 'lookUp'},
  },
};

export const ORDERED_DATA_FRAME_CREATION_METHODS: Array<DataFrameCreationMethod> = [
  DataFrameCreationMethod.INSIGHTS_BLOCK,
  DataFrameCreationMethod.REGISTRY_SCHEMA,
  DataFrameCreationMethod.PLATE_SCHEMA,
  DataFrameCreationMethod.DATA_CATALOG,
  DataFrameCreationMethod.UPLOAD_CSV,
  DataFrameCreationMethod.COMBINE_DATA_FRAMES,
  DataFrameCreationMethod.LOOK_UP,
];

/** @package */
export const DATA_FRAME_CREATION_NO_PREVIEW_PLACEHOLDER_TEXT = 'No table preview available yet';
